var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-content w-100"},[_c('div',{staticClass:"no-search-found position-relative text-center"},[_c('LmSvgIcon',{attrs:{"wrapperClass":"d-flex h-100 justify-content-center align-items-center flex-column","width":"8em","icon":"LmNoDataIcon","text":_vm.title ? _vm.title : _vm.$t('not_found_h1')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }